'use client'

import { useSyncExternalStore } from 'react'

type IListener = () => void

const activeContexts = new Set<string>()
const listeners = new Set<IListener>()

function subscribe(listener: IListener) {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}

function notify() {
    for (const l of listeners) l()
}

export function setDynamicIslandActive(contextId: string, active: boolean) {
    const changed = active ? !activeContexts.has(contextId) : activeContexts.has(contextId)
    if (!changed) return
    if (active) {
        activeContexts.add(contextId)
    } else {
        activeContexts.delete(contextId)
    }
    notify()
}

export function useHasOtherActiveDynamicIsland(excludeContextId: string): boolean {
    return useSyncExternalStore(subscribe, () => {
        for (const id of activeContexts) {
            if (id !== excludeContextId) return true
        }
        return false
    })
}
